import { render } from "./korean.vue?vue&type=template&id=e62845ce"
import script from "./korean.vue?vue&type=script&lang=js"
export * from "./korean.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__